import React from 'react';
import { Link } from 'react-router-dom';
import AdminNavbar from '../../components/admin/AdminNavbar';
import './AdminCommon.css';

/**
 * Admin de las políticas institucionales (menú Comunicaciones).
 * Por ahora son páginas estáticas; este panel permite verlas y, en el futuro, editarlas.
 */
const AdminPoliticas = () => {
  const politicas = [
    { path: '/politica-privacidad', titulo: 'Política de privacidad', desc: 'Información sobre manejo de datos personales' },
    { path: '/proteccion-menores', titulo: 'Protección a Menores', desc: 'Protocolo de cuidado y protección' },
    { path: '/tratamiento-datos', titulo: 'Tratamiento de datos', desc: 'Políticas de tratamiento de información' },
  ];

  return (
    <div className="admin-common">
      <AdminNavbar />
      <div className="container">
        <div className="admin-header">
          <Link to="/admin" className="btn btn-secondary">← Panel</Link>
          <h1>Políticas institucionales</h1>
          <p>Política de privacidad, Protección a Menores y Tratamiento de datos (del menú Comunicaciones).</p>
        </div>

        <div className="secciones-pastoral-admin">
          {politicas.map(({ path, titulo, desc }) => (
            <div key={path} className="seccion-pastoral-card">
              <h2>{titulo}</h2>
              <p className="seccion-preview-text">{desc}</p>
              <div className="seccion-pastoral-actions">
                <Link to={path} className="btn btn-primary" target="_blank" rel="noopener noreferrer">
                  Ver página
                </Link>
              </div>
              <p className="admin-politicas-hint">
                Contenido estático. Para editarlo contacte al desarrollador.
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminPoliticas;
